import React from "react";
import defaultIcon from "img/default-icon-company.png";

const getLogoUrl = (exchange, symbol) => {
  return `https://assets.earningscalls.biz/logo/${exchange.toLowerCase()}_${symbol.toLowerCase()}_300.png`;
};

export const CompanyLogo = (props) => {
  const { exchange, symbol } = props;
  if (!exchange || !symbol) {
    return <></>;
  }
  return (
    <img
      src={getLogoUrl(exchange, symbol)}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src = defaultIcon;
      }}
      alt="logo"
    />
  );
};

export const CompanyLogoDiv = (props) => {
  const { exchange, symbol, divClass } = props;
  const enabledCompanyLogosFeature = true;

  return (
    <div
      className={
        enabledCompanyLogosFeature ? `${divClass}` : `${divClass} d-none`
      }
    >
      <CompanyLogo {...{ exchange, symbol }} />
    </div>
  );
};
